import { createAction, props } from '@ngrx/store';

export const dummyAction = createAction('dummy');

export const loadUsers = createAction(
  '[User] Load Users',
  props<{ userIds: string[] }>()
);
export const loadUser = createAction(
  '[User] Load User',
  props<{ userId: string }>()
);
export const loadUserSuccess = createAction(
  '[User] Load User Success',
  props<{ users: any[] }>()
);

//Add userProfile
export const addOrUpdateUserProfile = createAction(
  '[UserProfile] ADDORUPDATE UserProfile',
  props<{ userProfile: any }>()
);
export const addOrUpdateUserProfileSuccess = createAction(
  '[UserProfile] ADDORUPDATE UserProfile Success',
  props<{ userProfile: any }>()
);

//LOAD
export const loadUserProfile = createAction(
  '[UserProfile] LOAD UserProfile',
  props<{ userId: any }>()
);
export const loadUserProfileSuccess = createAction(
  '[UserProfile] LOAD UserProfile Success',
  props<{ userProfile: any }>()
);
